<template>
  <div>
    <p class="title-page">Bloqueio de Parâmetros de Entrada de Notas</p>
    <TableBlock />
  </div>
</template>

<script>
import TableBlock from "../components/TableBlock.vue";

export default {
  name: "TableBlockNotes",

  components: {
    TableBlock,
  },
};
</script>
